module.exports = "/static/assets/f7f46bfccd0339b382ebdc84d8245b1a.png";